import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { TrimCarouselStyled } from '../TrimCarouselStyled';
import { rem } from 'polished';

export const TrimCarouselStyledAP = styled(TrimCarouselStyled)`
    .trimCarousel {
        @media (max-width: ${breakpoints.md}px) {
            padding-top: 0;
        }
    }

    .carouselArrows-wrapper {
        top: 0;
        height: 100%;

        &__btnsSection {
            .arrowBtn {
                background: ${({ theme }) => theme.colors.primaryBlack};
                opacity: 0.7;

                &--disabled {
                    background-color: ${({ theme }) => theme.colors.grey14};
                    border: 1px solid ${({ theme }) => theme.colors.grey12};
                    opacity: 1;

                    svg {
                        path {
                            stroke: ${({ theme }) => theme.colors.grey12};
                        }
                    }
                }
            }
        }

        .arrowBtn {
            width: ${rem('32px')};
            height: ${rem('32px')};
            align-self: center;

            &:hover {
                background: ${({ theme }) => theme.colors.primaryBlack};
                opacity: 1;

                svg {
                    path {
                        stroke: ${({ theme }) => theme.colors.white};
                    }
                }
            }

            svg {
                width: ${rem('20px')};
                height: ${rem('20px')};

                &:hover {
                }
            }
        }

        .currentSlideSection {
            align-self: flex-start;
        }
    }

    .react-multi-carousel-track {
        padding-top: ${rem('30px')};

        @media screen and (min-width: ${breakpoints.sm}px) {
            padding-top: 0;
        }
    }
`;
